<template>
  <WdsStack gap-sm direction-column>
    <WdsSelect
      v-model="selectedStatuses"
      multi-select
      class="tw-w-full"
      :label="meta.filter.quickFilter ? '' : $t('Status')"
      :list="statuses"
      :max-labels-visible="meta.filter.quickFilter ? 1 : 10"
      :placeholder="$t('All statuses')"
      can-deselect
      labels-primary
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack } from '@worksome/wds-components'
import { computed, ModelRef } from 'vue'
import { $t } from '@/composables/translation'
import { JobStatus } from '@/gql/graphql'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

defineProps<{ meta: FilterMetaDataProp }>()

const selectedStatuses: ModelRef<string[]> = defineModel({
  default: () => [],
})

const statusLabels: Record<string, string> = {
  [JobStatus.Draft]: $t('Draft'),
  [JobStatus.Active]: $t('Active'),
  [JobStatus.Completed]: $t('Completed'),
  [JobStatus.Removed]: $t('Removed'),
}

const orderedStatuses = [
  JobStatus.Draft,
  JobStatus.Active,
  JobStatus.Completed,
  JobStatus.Removed,
]

const statuses = computed(() =>
  orderedStatuses.map((value) => ({
    label: statusLabels[value] ?? value,
    value,
  })),
)
</script>
